import { hierarchy } from '@visx/hierarchy';
import { scaleColorTraffic } from 'js/utils/color';
import {
  faGauge,
  faGaugeHigh,
  faGaugeLow,
  faGaugeMax,
  faGaugeMin,
} from '@fortawesome/pro-regular-svg-icons';

export const DEFAULT_TILE_AREA = 20000;
export const DEFAULT_MIN_HEIGHT = 200;
export const TEXT_FOREGROUND_ALPHA = 0.8;
export const TEXT_DARK_HEX = '#2c2c2c';
export const TILE_INSET = 2;
export const LABEL_INSET = 8;
export const HEADER_HEIGHT_WITH_CHILDREN = 30;
export const HEADER_HEIGHT_LEAF = 56;
export const CHILD_TILE_GAP = 1.5;
export const CHILD_AREA_BORDER = 'rgba(255, 255, 255, 0.6)';
export const CHILD_AREA_RADIUS = 2;
export const CAPABILITY_RADIUS = 4;
export const UNSCORED_FILL = '#ffffff';
export const UNSCORED_STROKE = 'rgba(0,0,0,0.12)';
export const UNSCORED_STROKE_WIDTH = 1;

export function toFiniteNumber(value) {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

export function formatScore(score) {
  const finiteScore = toFiniteNumber(score);
  return finiteScore == null
    ? 'Unscored'
    : `${(finiteScore * 100).toFixed(1)}%`;
}

export function scoreFill(score) {
  const finiteScore = toFiniteNumber(score);
  if (finiteScore == null) {
    return UNSCORED_FILL;
  }
  return scaleColorTraffic(Math.max(0, Math.min(1, finiteScore)));
}

export function scoreIcon(score) {
  const finiteScore = toFiniteNumber(score);
  if (finiteScore == null) {
    return faGauge;
  } else if (finiteScore < 0.2) {
    return faGaugeMin;
  } else if (finiteScore < 0.4) {
    return faGaugeLow;
  } else if (finiteScore < 0.6) {
    return faGauge;
  } else if (finiteScore < 0.8) {
    return faGaugeHigh;
  }
  return faGaugeMax;
}

export function buildCapabilityRoot(capabilities) {
  const children = (capabilities || [])
    .filter(
      (capability) =>
        toFiniteNumber(capability.areaWeight) != null &&
        capability.areaWeight > 0
    )
    .map((capability) => ({
      ...capability,
      // Nested layout is a separate treemap; keep siblings flat for .sum().
      children: undefined,
      childCapabilities: capability.children || [],
    }));

  return hierarchy({ name: 'capabilities', children })
    .sum((d) => d.areaWeight || 0)
    .sort((a, b) => b.value - a.value);
}
